<app-page-bar></app-page-bar>

<app-page>
  <h2>{{title}}</h2>

  <section>
    <div class="filter">
      <mat-form-field>
        <mat-icon matPrefix>search</mat-icon>
        <input placeholder="Invoice ID" type="number" matInput [value]="q.invoice_id || ''" (change)="updateQuery({invoice_id: $event.target.value})">
      </mat-form-field>
      <button type="button" mat-icon-button (click)="reset()"><mat-icon>clear</mat-icon></button>
    </div>

    <div class="table-container mat-elevation-z8">
      <mat-table #table [dataSource]="dataSource">

        <ng-container matColumnDef="created_at">
          <mat-header-cell *matHeaderCellDef>Created</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.created_at | date:'short'}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="amount">
          <mat-header-cell *matHeaderCellDef>Amount</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.amount | currency:'EUR'}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="is_payment">
          <mat-header-cell *matHeaderCellDef>Type</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.is_payment ? 'Payment' : 'Compensation'}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="client_name">
          <mat-header-cell *matHeaderCellDef>Client</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.invoice_context?.client_name}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="end_customer_name">
          <mat-header-cell *matHeaderCellDef>End Customer</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.invoice_context?.end_customer_name}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="invoice_id">
          <mat-header-cell *matHeaderCellDef>Invoice</mat-header-cell>
          <mat-cell *matCellDef="let element"><a [routerLink]="['/invoices', element.invoice_id]">{{element.invoice_id}}</a></mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="columns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: columns;" matRipple [routerLink]="['/invoices', row.invoice_id]"></mat-row>

      </mat-table>
    </div>
  </section>
</app-page>
